module.exports = __webpack_public_path__ + "img/mockup_weather-preview.abe48766.jpg";